/* @flow */

import FieldKeysGeneric from './FieldKeysGeneric';

export default {
  ...FieldKeysGeneric,
  HEADLINE_WIDGET: 'dsw.headline.widget.label',
  BUTTON_LOCATE_ME_TOOLTIP: 'dsw.button.locateMe.tooltip.label',
  INPUT_SEARCH_PLACEHOLDER: 'dsw.input.search.placeholder.label',
  BUTTON_SEARCH: 'dsw.button.search.label',
  PARAGRAPH_RESULTS_SUGGESTED_COUNT: 'dsw.paragraph.resultsCountSuggested.label',
  PARAGRAPH_SEARCH_INSTEAD_LINK: 'dsw.paragraph.searchInstead.label',
  TAB_MODE_LIST: 'dsw.tab.mode.list.label',
  TAB_MODE_MAP: 'dsw.tab.mode.map.label',
  DROPDOWN_FILTER: 'dsw.dropdown.filter.label',
  //DROPDOWN_FILTER_PLACEHOLDER: 'dsw.dropdown.filter.placeholder.label',
  DROPDOWN_FILTER_HIDE: 'dsw.dropdown.filter',
  BUTTON_DEALER_SELECT: 'dsw.button.dealerSelect.label'
};
